import { render, staticRenderFns } from "./UcPrinterSelector.yaml?vue&type=template&id=427087ad&component"
import script from "./UcPrinterSelector.yaml?vue&type=script&lang=ts&component"
export * from "./UcPrinterSelector.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports